import type { ReportsMessageId } from "./reports.fr";

/** Signalements in Arabic. Same keys and {placeholders} as reports.fr.ts. */
export const reportsAr: Record<ReportsMessageId, string> = {
  "reports.filter.severity": "الخطورة",
  "reports.filter.status": "الحالة",
  "reports.filter.all": "الكل",
  "reports.filter.reviewOverdue": "مراجعة إيقاف متأخرة",
  "reports.list.loading": "جارٍ تحميل البلاغات…",
  "reports.list.loadFailed": "تعذّر تحميل البلاغات.",
  "reports.list.empty": "لا توجد بلاغات لهذه المرشِّحات.",
  "reports.list.aria": "البلاغات",
  "reports.list.by": "أبلغ عنه {name}",
  "reports.list.aboutSubject": "{count} بلاغات بشأن هذا الشخص",
  "reports.pick": "اختر بلاغًا من القائمة.",
  "reports.loading": "جارٍ تحميل البلاغ…",
  "reports.loadFailed": "تعذّر تحميل هذا البلاغ.",
  "reports.notFound": "هذا البلاغ غير موجود. أعد تحميل القائمة.",
  "reports.refreshFailed": "تعذّر تحديث البلاغ: يُعرض كما كان.",
  "reports.dismiss": "إغلاق",

  "reports.severity.critical": "حرجة",
  "reports.severity.high": "عالية",
  "reports.severity.medium": "متوسطة",
  "reports.severity.low": "منخفضة",
  "reports.status.open": "مفتوح",
  "reports.status.investigating": "قيد التحقيق",
  "reports.status.decided": "صدر فيه قرار",
  "reports.status.appealed": "قيد الطعن",
  "reports.status.closed": "مغلق",
  "reports.verdict.none": "لا عقوبة",
  "reports.verdict.warning": "إنذار",
  "reports.verdict.temporary_suspension": "إيقاف مؤقت",
  "reports.verdict.permanent_ban": "حظر نهائي",
  "reports.appeal.upheld": "القرار مُثبَّت",
  "reports.appeal.overturned": "القرار مُلغى",
  "reports.source.app": "من التطبيق",
  "reports.source.phone": "عبر الهاتف",
  "reports.source.console": "فتحه الفريق",

  "reports.category.assault": "اعتداء",

  "reports.new.title": "بلاغ جديد",

  "reports.new.source": "كيف وصلنا",

  "reports.new.byPhone": "عبر الهاتف",

  "reports.new.byStaff": "لاحظه الفريق",

  "reports.new.subject": "الشخص المُبلَّغ عنه",

  "reports.new.reporter": "من قدّم البلاغ",

  "reports.new.reporterHint": "معرّفه، إذا بلّغ عميل. اتركه فارغًا إذا لاحظه الفريق.",

  "reports.new.category": "ما الذي حدث",

  "reports.new.categoryHint": "تُشتق الخطورة من هذا. يمكن تغييرها لاحقًا.",

  "reports.new.description": "ما قيل لنا",

  "reports.new.descriptionHint": "بكلماته قدر الإمكان. يقرؤه من يتولى التحقيق.",

  "reports.new.submit": "فتح البلاغ",

  "reports.new.needSubject": "اختر الشخص المُبلَّغ عنه.",

  "reports.new.needDescription": "صِف ما حدث، في جملة على الأقل.",

  "reports.new": "بلاغ جديد",
  "reports.category.sexual_violence": "عنف جنسي",
  "reports.category.serious_theft": "سرقة جسيمة",
  "reports.category.weapon_threat": "تهديد بسلاح",
  "reports.category.theft": "سرقة",
  "reports.category.threats": "تهديدات",
  "reports.category.harassment": "تحرّش",
  "reports.category.fraud": "احتيال",
  "reports.category.unsafe_work": "عمل خطِر",
  "reports.category.no_show": "عدم الحضور إلى الموعد",
  "reports.category.other": "أخرى",

  "reports.pill.suspended": "موقوف",
  "reports.pill.reviewOverdue": "مراجعة متأخرة",
  "reports.pill.legalHold": "تجميد قانوني",

  "reports.detail.versionTitle": "نسخة البلاغ المعروضة: تُرسَل مع كل إجراء.",
  "reports.detail.critical": "بلاغ حرج",
  "reports.detail.needsPolice": "لم يُحَل إلى الشرطة بعد. أُبلِغ المالكون.",
  "reports.detail.subject": "الشخص المُبلَّغ عنه",
  "reports.detail.reporter": "صاحب البلاغ",
  "reports.detail.openedBy": "فتحه {name}",
  "reports.detail.noReporter": "غير معروف",
  "reports.detail.job": "الطلب المرتبط",
  "reports.detail.case": "الملف الأصلي",
  "reports.detail.subjectCase": "ملف الشخص المُبلَّغ عنه",
  "reports.detail.openCase": "فتح الملف ←",
  "reports.detail.noSubjectCase": "لا يوجد: يُفتح عند الإيقاف أو الطعن",
  "reports.detail.none": "لا يوجد",
  "reports.detail.description": "ما حدث",
  "reports.detail.restrictions": "الإيقافات والحظر",
  "reports.detail.restrictionsHint":
    "يستمر الإيقاف حتى قرار الفريق. موعد المراجعة ليس نهاية: بعد تجاوزه يبقى الشخص موقوفًا وتصبح المراجعة متأخرة.",
  "reports.detail.verdict": "الحكم",
  "reports.detail.decidedBy": "من {name}، بتاريخ {date}",
  "reports.detail.appeal": "الطعن",
  "reports.detail.appealedAt": "استُلم الطعن بتاريخ {date}",
  "reports.detail.appealPending": "بانتظار القرار",
  "reports.detail.police": "الإحالات إلى الشرطة",
  "reports.detail.shared": "بيانات مُسلَّمة: {categories} · {name}، {date}",
  "reports.detail.holds": "التجميدات القانونية",
  "reports.detail.holdPlaced": "سارٍ منذ {date} · {name}",
  "reports.detail.holdReleased": "رُفع بتاريخ {date} · {name}",
  "reports.detail.related": "بلاغات أخرى بشأن هذا الشخص",
  "reports.detail.timeline": "التسلسل الزمني",
  "reports.detail.actions": "الإجراءات",
  "reports.detail.noActions": "لا يوجد إجراء متاح لأدوارك على هذا البلاغ.",

  "reports.restriction.interim_suspension": "إيقاف أثناء التحقيق",
  "reports.restriction.temporary_suspension": "إيقاف مؤقت",
  "reports.restriction.permanent_ban": "حظر نهائي",
  "reports.restriction.untilDecision": "حتى قرار الفريق",
  "reports.restriction.untilDecisionReviewBy": "حتى قرار الفريق · تجب مراجعته قبل {date}",
  "reports.restriction.until": "حتى {date}",
  "reports.restriction.permanent": "نهائي، ما لم يُقبل الطعن",
  "reports.restriction.switchedOff": "معطّل: {features}",
  "reports.restriction.lifted": "رُفع بتاريخ {date} من {name}",
  "reports.restriction.inForce": "سارٍ",
  "reports.restriction.ended": "منتهٍ",

  "reports.entry.report": "بلاغ",
  "reports.entry.evidence": "دليل",
  "reports.entry.severity_changed": "تغيّرت الخطورة",
  "reports.entry.suspended": "إيقاف",
  "reports.entry.suspension_lifted": "رُفع الإيقاف",
  "reports.entry.verdict": "الحكم",
  "reports.entry.appeal": "طعن",
  "reports.entry.appeal_decided": "صدر قرار الطعن",
  "reports.entry.police_referral": "أُحيل إلى الشرطة",
  "reports.entry.police_data_shared": "بيانات سُلّمت إلى الشرطة",
  "reports.entry.legal_hold_placed": "فُرض تجميد قانوني",
  "reports.entry.legal_hold_released": "رُفع التجميد القانوني",
  "reports.entry.linked": "أُضيف رابط",
  "reports.entry.suspension_withheld": "لم يُطبَّق الإيقاف",
  "reports.entry.system": "النظام",
  "reports.entry.evidenceLink": "عرض المستند ←",

  "reports.police.category.identity": "الهوية",
  "reports.police.category.contact_details": "بيانات الاتصال",
  "reports.police.category.id_document": "وثيقة الهوية",
  "reports.police.category.messages": "الرسائل",
  "reports.police.category.job_details": "تفاصيل الطلب",
  "reports.police.category.report_and_evidence": "البلاغ والأدلة",
  "reports.police.category.audit_log": "سجل التدقيق",
  "reports.police.category.payments": "المدفوعات",
  "reports.hold.entity.safety_report": "هذا البلاغ",
  "reports.hold.entity.user": "الحساب",
  "reports.hold.entity.job": "الطلب",
  "reports.hold.entity.conversation": "المحادثة",

  "reports.block.ownVerdict": "أنت من أصدر الحكم: يجب أن يبتّ شخص آخر في الطعن.",
  "reports.block.ownerOnly": "لا يسلّم البيانات إلى الشرطة إلا المالك.",
  "reports.block.noReferral": "أحِل البلاغ إلى الشرطة أولًا لتسجيل البيانات المُسلَّمة.",

  "reports.action.evidence": "إضافة دليل",
  "reports.action.severity": "تغيير الخطورة",
  "reports.action.suspend": "إيقاف أثناء التحقيق",
  "reports.action.lift": "رفع الإيقاف",
  "reports.action.verdict": "إصدار الحكم",
  "reports.action.ban": "حظر نهائي",
  "reports.action.appeal": "البتّ في الطعن",
  "reports.action.police": "إحالة إلى الشرطة",
  "reports.action.share": "تسجيل بيانات مُسلَّمة",
  "reports.action.hold": "فرض تجميد قانوني",
  "reports.action.release": "رفع التجميد القانوني",

  "reports.dialog.evidence.title": "إضافة دليل · {reference}",
  "reports.dialog.evidence.body": "صِف المستند، وإن كان على الإنترنت فأضف رابطه. يُضاف إلى التسلسل الزمني.",
  "reports.dialog.severity.title": "تغيير الخطورة · {reference}",
  "reports.dialog.severity.body": "البلاغ الحرج يُبلِغ المالكين ويجب إحالته إلى الشرطة. اذكر سبب التغيير.",
  "reports.dialog.suspend.title": "إيقاف · {reference}",
  "reports.dialog.suspend.body":
    "لن يتمكن {name} من استخدام Walliyo، إلا للتواصل مع الفريق وتقديم طعن، حتى قرار الفريق. يُطبَّق موعد للمراجعة: وهو ليس نهاية للإيقاف. يُبلَّغ الشخص داخل التطبيق ويُفتح ملف باسمه.",
  "reports.dialog.lift.title": "رفع الإيقاف · {reference}",
  "reports.dialog.lift.body": "يستعيد {name} الوصول إلى Walliyo فورًا. اذكر السبب.",
  "reports.dialog.verdict.title": "إصدار الحكم · {reference}",
  "reports.dialog.verdict.body":
    "يقرأ {name} السبب داخل التطبيق، مع إمكانية الطعن مرة واحدة. لا يُعاقَب أحد دون سبب مكتوب.",
  "reports.dialog.ban.title": "حظر نهائي · {reference}",
  "reports.dialog.ban.body":
    "يفقد {name} الوصول إلى Walliyo نهائيًا، وتُحظر وثيقة هويته. يُعرض عليه السبب داخل التطبيق، ويمكنه الطعن مرة واحدة.",
  "reports.dialog.appeal.title": "البتّ في الطعن · {reference}",
  "reports.dialog.appeal.body":
    "الإلغاء يرفع ما فرضه الحكم. يقرأ {name} سببك داخل التطبيق. يجب أن يبتّ في الطعن شخص غير مُصدِر الحكم.",
  "reports.dialog.police.title": "إحالة إلى الشرطة · {reference}",
  "reports.dialog.police.body": "سجّل الجهة التي أُحيل إليها البلاغ. لا يُرسَل شيء من هنا.",
  "reports.dialog.share.title": "بيانات مُسلَّمة إلى الشرطة · {reference}",
  "reports.dialog.share.body": "سجّل بدقة ما سُلّم، فئةً فئة. يُحفظ هذا الأثر ويظهر في سجل التدقيق.",
  "reports.dialog.hold.title": "فرض تجميد قانوني · {reference}",
  "reports.dialog.hold.body": "لا يمكن حذف أي شيء يخص هذا البلاغ ما دام التجميد ساريًا، ولا حتى بقاعدة الاحتفاظ.",
  "reports.dialog.release.title": "رفع التجميد القانوني · {reference}",
  "reports.dialog.release.body": "تعود قواعد الاحتفاظ لتسري على كل ما كان التجميد يحميه.",

  "reports.field.evidence": "الدليل",
  "reports.field.evidenceUrl": "الرابط (اختياري)",
  "reports.field.evidenceUrlHint": "عنوان https://، مثل صورة مرفوعة في الملف.",
  "reports.field.severity": "الخطورة الجديدة",
  "reports.field.verdict": "الحكم",
  "reports.field.suspendedUntil": "موقوف حتى",
  "reports.field.toldReason": "السبب الذي يقرأه الشخص",
  "reports.field.toldHint": "جملة حقيقية، بكلمات يفهمها الشخص. 10 أحرف على الأقل.",
  "reports.field.decision": "القرار",
  "reports.field.station": "مركز الشرطة أو الفرقة",
  "reports.field.officerName": "اسم الضابط",
  "reports.field.officerContact": "بيانات اتصال الضابط (اختياري)",
  "reports.field.policeReference": "مرجع الشرطة (اختياري)",
  "reports.field.referral": "الإحالة",
  "reports.field.categories": "البيانات المُسلَّمة",
  "reports.field.shareDescription": "ما سُلّم بالضبط",
  "reports.field.shareDescriptionHint": "مثلًا: الرسائل من 3 إلى 5 مايو، نسخة ممسوحة من بطاقة الهوية.",
  "reports.field.reasonOptional": "السبب (اختياري)",

  "reports.problem.reason": "اكتب سببًا من {min} إلى {max} حرفًا.",
  "reports.problem.told": "اكتب السبب الذي يقرأه الشخص: {min} أحرف على الأقل.",
  "reports.problem.evidence": "صِف الدليل.",
  "reports.problem.url": "يجب أن يكون الرابط عنوان http:// أو https:// كاملًا.",
  "reports.problem.until": "اختر تاريخًا مستقبليًا لنهاية الإيقاف.",
  "reports.problem.police": "أدخل مركز الشرطة واسم الضابط (من 2 إلى 200 حرف لكل منهما).",
  "reports.problem.referral": "اختر الإحالة المعنية.",
  "reports.problem.categories": "حدّد فئة واحدة على الأقل من البيانات المُسلَّمة.",
  "reports.problem.shareDescription": "اذكر بالضبط ما سُلّم.",

  "reports.done.evidence": "أُضيف الدليل إلى {reference}.",
  "reports.done.severity": "تغيّرت خطورة {reference}.",
  "reports.done.suspend": "أُوقف الشخص حتى قرار الفريق ({reference}). أُبلِغ داخل التطبيق.",
  "reports.done.lift": "رُفع الإيقاف ({reference}).",
  "reports.done.verdict": "سُجّل الحكم على {reference}. أُبلِغ الشخص داخل التطبيق.",
  "reports.done.ban": "سُجّل الحظر على {reference}. أُبلِغ الشخص داخل التطبيق.",
  "reports.done.appeal": "صدر قرار الطعن على {reference}. أُبلِغ الشخص داخل التطبيق.",
  "reports.done.police": "سُجّلت الإحالة إلى الشرطة على {reference}.",
  "reports.done.share": "سُجّلت البيانات المُسلَّمة على {reference}.",
  "reports.done.hold": "فُرض تجميد قانوني على {reference}.",
  "reports.done.release": "رُفع التجميد القانوني عن {reference}.",

  "reports.error.stale": "تغيّر هذا البلاغ أثناء اطلاعك عليه. أعد تحميله وتحقق ثم حاول مجددًا.",
  "reports.error.refused": "رُفض الإجراء: لا تتضمن أدوارك الميزة اللازمة. اطلب الوصول من أحد المسؤولين.",
  "reports.error.appealRefused": "مرفوض: يجب أن يبتّ في الطعن شخص غير مُصدِر الحكم، ولديه HANDLE_APPEALS.",
  "reports.error.shareRefused": "مرفوض: لا يسلّم البيانات إلى الشرطة إلا المالك.",
  "reports.error.invalid": "مرفوض: لم يعد البلاغ في الحالة المطلوبة، أو أن أحد الحقول غير صالح. أعد تحميله وتحقق.",
  "reports.error.outcomeUnknown":
    "لا ردّ من الخادم: ربما سُجّل الإجراء. أعد المحاولة: لا يمكن تطبيق النقرة نفسها مرتين.",

  "reports.refused.wrongStatus": "مرفوض: لم يعد هذا البلاغ في هذه المرحلة، فلم يعد الإجراء ينطبق. أعد تحميله.",
  "reports.refused.alreadyRestricted": "مرفوض: هذا الشخص موقوف مسبقًا بسبب بلاغ آخر.",
  "reports.refused.notSuspended": "مرفوض: لم يعد لهذا البلاغ إيقاف ساري. أعد تحميله.",
  "reports.refused.suspendedUntilRequired": "يحتاج الإيقاف المؤقت إلى تاريخ انتهاء في المستقبل.",
  "reports.refused.ownVerdict": "مرفوض: أنت من أصدر هذا الحكم، لذا يجب أن يبتّ في الطعن شخص آخر.",
  "reports.refused.alreadyHeld": "هذا البلاغ خاضع مسبقًا لتجميد قانوني. أعد تحميله.",
  "reports.refused.notHeld": "لم يعد هذا البلاغ خاضعًا لتجميد قانوني. أعد تحميله.",
};
